import { View, type ViewProps } from 'react-native';
import { colors } from '../../theme/colors';
import { type SpacingScale, spacing } from '../../theme/spacing';

interface DividerProps extends ViewProps {
  orientation?: 'horizontal' | 'vertical';
  thickness?: number;
  color?: string;
  marginX?: SpacingScale;
  marginY?: SpacingScale;
  opacity?: number;
}

export const Divider = ({
  orientation = 'horizontal',
  thickness = 1,
  color = colors.border.default,
  marginX,
  marginY,
  opacity = 1,
  style,
  ...rest
}: DividerProps) => {
  const isHorizontal = orientation === 'horizontal';

  return (
    <View
      style={[
        {
          backgroundColor: color,
          opacity,
          width: isHorizontal ? '100%' : thickness,
          height: isHorizontal ? thickness : '100%',
          marginHorizontal: marginX ? spacing[marginX] : 0,
          marginVertical: marginY ? spacing[marginY] : 0,
        },
        style,
      ]}
      {...rest}
    />
  );
};
